import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiMail, FiLinkedin, FiHeart, FiCamera } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759337639185-RSG%20LOGO%20HORIZONTAL.png"
                alt="Richardson Strategy Group"
                className="h-6 w-auto"
                loading="lazy"
              />
            </div>
            <p className="text-secondary-600 text-sm leading-relaxed">
              Data-backed growth strategy for leaders who value clarity, inclusion, and humanity.
            </p>
            <div className="flex items-center space-x-2 text-sm text-secondary-500">
              <SafeIcon icon={FiHeart} className="w-4 h-4 text-red-500" />
              <span>Built with inclusion at the core</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-secondary-900">Quick Links</h3>
            <div className="space-y-2">
              <Link
                to="/about"
                className="block text-secondary-600 hover:text-primary-600 text-sm transition-colors"
              >
                About Richardson Strategy Group
              </Link>
              <Link
                to="/services"
                className="block text-secondary-600 hover:text-primary-600 text-sm transition-colors"
              >
                Our Services
              </Link>
              <Link
                to="/case-for-change"
                className="block text-secondary-600 hover:text-primary-600 text-sm transition-colors"
              >
                Why Change Matters
              </Link>
              <Link
                to="/contact"
                className="block text-secondary-600 hover:text-primary-600 text-sm transition-colors"
              >
                Start a Conversation
              </Link>
              <Link
                to="/privacy"
                className="block text-secondary-600 hover:text-primary-600 text-sm transition-colors"
              >
                Privacy Policy
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="font-semibold text-secondary-900">Get in Touch</h3>
            <div className="space-y-3">
              <a
                href="mailto:info@richardsonstrategy.group"
                className="flex items-center space-x-2 text-secondary-600 hover:text-primary-600 text-sm transition-colors"
              >
                <SafeIcon icon={FiMail} className="w-4 h-4" />
                <span>info@richardsonstrategy.group</span>
              </a>
              <a
                href="https://www.linkedin.com/company/richardson-strategy-group"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-secondary-600 hover:text-primary-600 text-sm transition-colors"
              >
                <SafeIcon icon={FiLinkedin} className="w-4 h-4" />
                <span>Connect on LinkedIn</span>
              </a>
            </div>
            <p className="text-xs text-secondary-500 mt-4">
              Philadelphia, PA • Serving clients nationwide
            </p>
          </div>
        </div>

        <div className="border-t border-secondary-200 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
            <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 space-y-2 sm:space-y-0">
              <p className="text-xs text-secondary-500">
                © 2024 Richardson Strategy Group. All rights reserved.
              </p>
              {/* Photo Credits Link */}
              <Link
                to="/attributions"
                className="inline-flex items-center space-x-1 text-xs text-secondary-400 hover:text-secondary-600 transition-colors"
              >
                <SafeIcon icon={FiCamera} className="w-3 h-3" />
                <span>Photo credits</span>
              </Link>
            </div>
            <p className="text-xs text-secondary-500">
              Growth is messy, but clarity is worth the work.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;